import React, { useState, useEffect } from "react";
import "../css/BoardingCard.css";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { LuDownload } from "react-icons/lu";
import bgTop from "../assets/boarding_design-1.png";
import bgBottom from "../assets/boarding_design_2.png";

const BoardingCard = ({
  item,
  isEditable = false,
  onClose,
  onSave,
  onAddService,
  onDelete,
  tag,
}) => {
  // Editable state
  const [editedTitle, setEditedTitle] = useState(item.title);
  const [editedSubTitle, setEditedSubTitle] = useState(item.subtitle);
  const [editedSubscribedPrice, setEditedSubscribedPrice] = useState(
    item.subscribedPrice
  );
  const [editedUnsubscribedPrice, setEditedUnsubscribedPrice] = useState(
    item.unsubscribedPrice
  );

  // Input mode toggles
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [isEditingSubtitle, setIsEditingSubTitle] = useState(false);
  const [isEditingSubscribedPrice, setIsEditingSubscribedPrice] =
    useState(false);
  const [isEditingUnsubscribedPrice, setIsEditingUnsubscribedPrice] =
    useState(false);
  // Format price for display
  const formatPrice = (value) => {
    const number = Number(value) || 0;
    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  // Sync with incoming props
  useEffect(() => {
    setEditedTitle(item.title);
    setEditedSubTitle(item.subtitle);
    setEditedSubscribedPrice(item.subscribedPrice);
    setEditedUnsubscribedPrice(item.unsubscribedPrice);

    setIsEditingTitle(false);
    setIsEditingSubTitle(false);
    setIsEditingSubscribedPrice(false);
    setIsEditingUnsubscribedPrice(false);
  }, [item]);

  // Handle Enter key for inputs
  const handleInputKeyDown = (e, field) => {
    if (e.key === "Enter") {
      if (field === "title") setIsEditingTitle(false);
      if (field === "subtitle") setIsEditingSubTitle(false);
      if (field === "subscribed") setIsEditingSubscribedPrice(false);
      if (field === "unsubscribed") setIsEditingUnsubscribedPrice(false);
    }
  };

  // Save handler
  const handleSaveClick = () => {
    onSave({
      ...item,
      title: editedTitle,
      subtitle: editedSubTitle,
      subscribedPrice: Number(editedSubscribedPrice),
      unsubscribedPrice: Number(editedUnsubscribedPrice),
    });
  };

  // Render promo badge
  const renderBadge = () => {
    if (tag === "Popular") return <span className="boarding-popular-badge">Popular</span>;
    if (tag === "Great Deals") return <span className="boarding-greatDeals-badge">Great Deals</span>;
    if (tag === "Steal Deals") return <span className="boarding-stealDeals-badge">Steal Deals</span>;
    return null;
  };

  return (
    <div className={`boarding-card-wrapper ${isEditable ? "editable-modal" : ""}`}>
      {isEditable ? (
        <div className="boarding-card boarding-modal-card">
          <img src={bgTop} alt="top design" className="card-top-bg" />
          {renderBadge()}

          {/* Editable header */}
          <div className="boarding-card-header">
            <div className="boarding-title-card boarding-edit">
              {isEditingTitle ? (
                <input
                  type="text"
                  value={editedTitle}
                  onChange={(e) => setEditedTitle(e.target.value)}
                  onBlur={() => setIsEditingTitle(false)}
                  onKeyDown={(e) => handleInputKeyDown(e, "title")}
                  autoFocus
                  className="price-input"
                />
              ) : (
                <h3 onClick={() => setIsEditingTitle(true)}>{editedTitle}</h3>
              )}

              {isEditingSubtitle ? (
                <input
                  type="text"
                  value={editedSubTitle}
                  onChange={(e) => setEditedSubTitle(e.target.value)}
                  onBlur={() => setIsEditingSubTitle(false)}
                  onKeyDown={(e) => handleInputKeyDown(e, "subtitle")}
                  autoFocus
                  className="price-input"
                />
              ) : (
                <p
                  className="boarding-subtitle"
                  onClick={() => setIsEditingSubTitle(true)}
                >
                  {editedSubTitle}
                </p>
              )}
            </div>
          </div>

          {/* Editable price */}
          <div className="boarding-price-details boarding-edit-price">
      <p className="add-package-boarding-text1">
        Subscribed User Price:{" "}
        {isEditingSubscribedPrice ? (
          <input
            type="number"
            value={editedSubscribedPrice}
            onChange={(e) => setEditedSubscribedPrice(e.target.value)}
            onBlur={() => setIsEditingSubscribedPrice(false)}
            onKeyDown={(e) => handleInputKeyDown(e, "subscribed")}
            autoFocus
            className="price-input"
            placeholder="₹0"
          />
        ) : (
          <span
            className="boarding-price"
            onClick={() => setIsEditingSubscribedPrice(true)}
          >
            ₹{formatPrice(editedSubscribedPrice)}
          </span>
        )}
      </p>

      <p className="add-package-boarding-text1">
        Unsubscribed User Price:{" "}
        {isEditingUnsubscribedPrice ? (
          <input
            type="number"
            value={editedUnsubscribedPrice}
            onChange={(e) => setEditedUnsubscribedPrice(e.target.value)}
            onBlur={() => setIsEditingUnsubscribedPrice(false)}
            onKeyDown={(e) => handleInputKeyDown(e, "unsubscribed")}
            autoFocus
            className="price-input"
            placeholder="₹0"
          />
        ) : (
          <span
            className="boarding-price"
            onClick={() => setIsEditingUnsubscribedPrice(true)}
          >
            ₹{formatPrice(editedUnsubscribedPrice)}
          </span>
        )}
      </p>
    </div>

          {/* Save / Close */}
          <div className="edit-btns">
            <button className="boarding-save-btn" onClick={handleSaveClick}>
              <LuDownload className="add-package-icon" color="#EBA8BF" />
              Save
            </button>
          </div>
          <span className="close-btn" onClick={onClose}>Close</span>

          <img src={bgBottom} alt="bottom design" className="card-bottom-bg" />
        </div>
      ) : (
        <div className="boarding-card">
          <img src={bgTop} alt="top design" className="card-top-bg" />
          {renderBadge()}

          <div className="boarding-container">
            <div className="boarding-left-side">
              <div className="boarding-card-header">
                <div className="boarding-title-card">
                  <h3>{item.title}</h3>
                  <p className="boarding-subtitle">{item.subtitle}</p>
                </div>
              </div>

          <div className="boarding-price-details">
  <p>
    Subscribed User Price:{" "}
    <span className="boarding-price">₹{formatPrice(item.subscribedPrice)}</span>
  </p>
  <p>
    Unsubscribed User Price:{" "}
    <span className="boarding-price">₹{formatPrice(item.unsubscribedPrice)}</span>
  </p>
</div>

            </div>

            <div className="boarding-card-actions">
              <button className="boarding-edit-btn" onClick={onAddService}>
                <FiEdit size={20} color="#000" /> Edit
              </button>
              <button className="boarding-delete-btn" onClick={onDelete}>
                <RiDeleteBin6Fill size={34} />
              </button>
            </div>
          </div>

          <img src={bgBottom} alt="bottom design" className="card-bottom-bg" />
        </div>
      )}
    </div>
  );
};

export default BoardingCard;
